// extracted by mini-css-extract-plugin
module.exports = {"Important":"Important_Important__LjqOB"};